import { api } from './config/axios';
import { store } from '../store';

export const getTransactionsHistory = (query) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/transaction', query, config);
};

export const refundTransaction = (transactionId) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return api.get(`/api/v1/admin/refund/${transactionId}`, {}, config);
};

export const completeTransaction = (transactionId, payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return api.put(`/api/v1/admin/transaction/manual/${transactionId}`, payload, config);
};

export const generateProfitAndLossReport = async (dateRange) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/transaction/profit', dateRange, config);
};

export const getTopUsersAnalysis = async (params) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/analytics/top-users', params, config);
};

export const getInactiveUsersAnalysis = async (params) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/analytics/inactive-users', params, config);
};

export const generateAdminTransactionReport = async (dateRange) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/statistic', dateRange, config);
};

export const getExternalFundingTransaction = async (reference) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/external/funding', { reference }, config);
};

export const getExternalPurchaseTransaction = async (reference) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/external/purchase', { reference }, config);
};
